const popupContainer = document.getElementById("cart-popup");
const closePopupBtn = document.getElementById("close-cart-popup");
const cartBtns = document.querySelectorAll("a[href='/cart']");

if(cartBtns.length !== 0) {
    cartBtns.forEach(target => {
        target.addEventListener("click", e => {
            e.preventDefault();

            buildCart(false);
        })
    })
}

closePopupBtn.addEventListener("click", e => {
    closePopupContainer();
});


const addToCart = (items, route) => {
    let formData = { items: items };

    // POST
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
      .then(response => {
          
        if(route !== undefined) {
            window.location.href = route;
        } else { buildCart(false); }

        
        
        return response.json();
    })
      .catch((error) => {
        console.error('Error:', error);
    });

};

const updateCart = (updates) => {
    let formData = { updates: updates };

    // POST
    fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
      .then(response => {
        buildCart(true);
        return response.json();
    })
      .catch((error) => {
        console.error('Error:', error);
    });
}

// BUILD CART INNER HTML
const buildCart = (update) => {
    const api_url = "/cart.js";

    async function getapi(url) {
        const response = await fetch(url);
        var data = await response.json();
        if (response) { hideloader(); }
        show(data);
    }
    getapi(api_url);

    function hideloader() {
        // HIDE THE LOADER
        // document.getElementById('loading').style.display = 'none';
    }
    
    function show(data) {
        data.items.forEach(item => {
            item.price = (parseInt(item.original_price) / 100).toLocaleString('en-US', { style: 'currency', currency: "USD" }).replace(/(\.[0-9]*?)0+/g, "");
        });
        data.total_price = (parseInt(data.total_price) / 100).toLocaleString('en-US', { style: 'currency', currency: data.currency }).replace(/(\.[0-9]*?)0+/g, "");

        const source = document.getElementById("CartItemTemplate").innerHTML;
        const compiledTemplate = Handlebars.compile(source);
        const generatedHTML = compiledTemplate(data);
        const empty = document.getElementById("cart-items");

        empty.innerHTML = generatedHTML;

        buildFormElements();

        update ? updateCartPopup() : openCartPopup();
    }
}
const buildFormElements = () => {
    let form = document.getElementById("popup-form");
    let quantityArr = popupContainer.querySelectorAll(".number");

    let checkoutForm = document.forms.checkout;
    checkoutForm.addEventListener("submit", e => {
        e.preventDefault();
        let terms = checkoutForm.querySelector("input[name='terms']");
        terms.checked ? window.location.href = '/checkout' : window.alert("You must agree to the terms and conditions to continue.");
    });

    form.submit = () => {
        let targets = form.querySelectorAll("input[type='number']");
        let updates = {};


        targets.forEach(target => {
            updates[target.dataset.id] = target.value;
        });

        updateCart(updates);
    };

    quantityArr.forEach(container => {
        let input = container.querySelector('input');
        let plusBtn = container.querySelector('[data-btn="plus"]');
        let minusBtn = container.querySelector('[data-btn="minus"]');
        let step = parseInt(input.step);

        plusBtn.addEventListener('click', (e) => {
            e.preventDefault();
            
            val = parseInt(input.value)
            if(val < parseInt(input.max)) {input.value = val + step}

            form.submit();
        });

        minusBtn.addEventListener('click', (e) => {
            e.preventDefault();
            val = parseInt(input.value);
            if(val > parseInt(input.min)) {input.value = val - step} else {input.value = 0;}

            form.submit();
        });
    });
}

// Cart Animations
const openCartPopup = () => {
    popupContainer.classList.remove("hidden");
    const cartItems = popupContainer.querySelectorAll(".\\@cart-item");

    let tl = gsap.timeline();
    tl.to(popupContainer, { autoAlpha: 1, duration: 0.3 }, 0)
      .to(popupContainer.children[0], { autoAlpha: 1, x: 0, duration: 0.5 }, 0)
      .to(cartItems, { autoAlpha: 1, x: 0, duration: 0.5, stagger: 0.1 }, 0.4);
}
const updateCartPopup = () => {
    const cartItems = popupContainer.querySelectorAll(".\\@cart-item");

    cartItems.forEach(target => {
        target.classList.remove("opacity-0");
        target.classList.remove("translate-x-16");
    })
}
const closePopupContainer = () => {
    let tl = gsap.timeline();
    const cartItems = popupContainer.querySelectorAll(".\\@cart-item");

    tl.to(popupContainer, { autoAlpha: 0, duration: 0.3 }, 0)
      .to(popupContainer.children[0], { autoAlpha: 0, x: 384, duration: 0.3 }, 0)
      .to(cartItems, { autoAlpha: 0, x: 64, duration: 0.3 }, 0);
}


// Add to cart buttons
const forms = document.querySelectorAll("form[action='/cart/add']");
if(forms.length !== 0) {
    forms.forEach(form => {
        const buynowBtn = form.querySelector(".\\@buynow");
        if(buynowBtn !== null ) {
            buynowBtn.addEventListener('click', e => {
                e.preventDefault();
                let items = [];
    
                items.push({
                    id: form.querySelector("input[name='id']").value,
                    quantity: form.querySelector("input[name='quantity']").value,
                });
                addToCart(items, buynowBtn.dataset.route);
            });
        }

        form.addEventListener('submit', e => {
            e.preventDefault();
            let items = [];

            items.push({
                id: form.querySelector("input[name='id']").value,
                quantity: form.querySelector("input[name='quantity']").value,
            });
            addToCart(items, undefined);
        });
        
    });
};





